<div class="flex items-center justify-center h-screen bg-gray-50 p-4">
  <div class="text-center bg-white shadow-md rounded-lg p-8 max-w-md w-full">
    <h2 class="text-2xl font-bold text-gray-800 mb-4">Unauthorized Access</h2>
    <p class="text-gray-600 mb-6">You do not have the necessary permissions to access this section of the application. Please sign out and verify your account credentials.</p>
    <div class="flex flex-col items-center space-y-4">
      <button mat-raised-button (click)="logout()" color="warn" class="bg-red-500 text-white px-6 py-3 rounded-lg hover:bg-red-600 transition duration-300 ease-in-out w-full">Sign Out</button>
      <p class="text-xs text-gray-500">Contact support if you believe this is an error.</p>
    </div>
  </div>
</div>
